// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ac6a74e4","455":"3d7665cd"}[chunkId] + ".chunk.js";
};